// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fetch } from "@insite/client-framework/ServerSideRendering";

const generatePdfUrl = "/api/serc/hotSheet/GeneratePdf";

export async function genereatePdfService(parameter: { html: string }) {
    const response = await fetch(generatePdfUrl, {
        method: "POST",
        body: JSON.stringify(parameter.html),
        headers: {
            Accept: "application/pdf",
            "Content-Type": "application/json",
        },
    });
    return response.blob();
}
